import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-responsive-list';
import { fetchNotPublishedPostsWithPagination } from 'dash-front/campaign/actions/withPagination';
import { Paper } from 'material-ui';
import { grey50, grey200 } from 'material-ui/styles/colors';
import { getEntities } from 'dash-front/selectors';
import { safeParse } from 'dash-front/helpers';
import { fetchPostsByCampaignsAndStatuses } from 'dash-front/admin/actions/posts';
import SettingsIcon from 'material-ui/svg-icons/action/settings-applications';
import { selectIds } from 'dash-front/selectors/pagination';
import PostImage from 'dash-front/campaign/containers/Posts/PostImage';
import Pagination from 'dash-front/campaign/containers/Pagination';
import Post from './Post';

import { FINISHED_REQ_DELAY } from 'dash-front/constants';

const FETCH_INTERVAL_SEC = 15;

const PostsList = connect(state => ({
    selectedCampaigns: _.get(state.routing, ['location', 'query', 'campaigns']),
    selectedStatuses: _.get(state.routing, ['location', 'query', 'statuses']),
    isPending: _.get(getEntities(state), ['GET:hub', 'isPending']),
    ids: selectIds(state.pagination, 'hub')
}))(
    class _PostsList extends React.PureComponent {
        componentDidMount() {
            const { dispatch } = this.props;
            this.fetchData(this.props.selectedCampaigns, this.props.selectedStatuses);

            this.fetchInterval = window.setInterval(() => {
                this.fetchData(this.props.selectedCampaigns, this.props.selectedStatuses);
                // dispatch(fetchNotPublishedPostsWithPagination(safeParse(this.props.selectedCampaigns)));
            }, FETCH_INTERVAL_SEC * 1000);
        }

        componentWillReceiveProps({ isFinished, postIds, selectedCampaigns, selectedStatuses }) {
            if (this.props.selectedCampaigns !== selectedCampaigns) {
                this.fetchData(selectedCampaigns, selectedStatuses);
            }
            if (this.props.selectedStatuses !== selectedStatuses) {
                this.fetchData(selectedCampaigns, selectedStatuses);
            }

            if (isFinished !== this.props.isFinished) {
                if (isFinished) {
                    window.clearTimeout(this.timer);
                    this.timer = setTimeout(() => this.setState({ ready: isFinished }), FINISHED_REQ_DELAY);
                } else {
                    window.clearTimeout(this.timer);
                    this.setState({
                        ready: isFinished || Array.isArray(postIds)
                    });
                }
            }
        }

        fetchData = (campaignStr, statusStr) => {
            const ids = safeParse(campaignStr);
            const statuses = safeParse(statusStr);
            if (Array.isArray(ids)) {
                this.props.dispatch(fetchPostsByCampaignsAndStatuses(ids, statuses));
            }
        };

        onPageChange = () => {
            this.fetchData(this.props.selectedCampaigns, this.props.selectedStatuses);
        };

        render() {
            const { ids, isPending } = this.props;
            if (!ids || isPending) {
                return <div>No data</div>;
            }
            return (
                <div>
                    <div
                        style={{
                            fontSize: 24,
                            lineHeight: '28px',
                            color: '#3f51b5',
                            padding: '18px 24px',
                            backgroundColor: '#f9f9f9',
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        <SettingsIcon style={{ width: 24, height: 24, marginRight: 20 }} color="#3f51b5" /> Moderation
                        Hub
                    </div>
                    {ids.map(id => <Post id={id} key={id} />)}

                    <Pagination entity={'hub'} fetchFunction={this.onPageChange} />
                </div>
            );
        }
    }
);

export default PostsList;



/** WEBPACK FOOTER **
 ** ../src/dash/front/admin/components/Hub/PostsList.js
 **/